// extracted by mini-css-extract-plugin
export default {"nodataBox":"NoData_nodataBox__L4fA2"};